import { Dialog, DialogPanel, DialogBackdrop } from "@headlessui/react";
import { useState, useEffect } from "react";

const Countdown = ({ isOpen, onCountdownComplete }) => {
  const [countdown, setCountdown] = useState(5);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setCountdown(5); // Reset when not open
      setIsAnimating(false);
      return;
    }

    if (countdown === 0) {
      const timer = setTimeout(() => {
        onCountdownComplete();
      }, 1000); // Show message for 1s
      return () => clearTimeout(timer);
    }

    // Trigger animation before countdown change
    setIsAnimating(true);
    const animationTimer = setTimeout(() => {
      setIsAnimating(false);
    }, 100);

    const timer = setTimeout(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => {
      clearTimeout(timer);
      clearTimeout(animationTimer);
    };
  }, [isOpen, countdown, onCountdownComplete]);

  return (
    <Dialog open={isOpen} onClose={() => {}} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel
          transition
          className="flex flex-col items-center justify-center gap-4 rounded-xl p-8 text-white backdrop-blur-lg data-[closed]:-translate-y-1/2 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        >
          {countdown > 0 ? (
            <>
              <p className="text-xl font-semibold">
                Your interview will begin in...
              </p>
              <div className="relative h-32 w-32 flex items-center justify-center overflow-hidden">
                <span
                  className={`text-8xl font-bold transition-all duration-500 ease-out ${
                    isAnimating
                      ? "transform translate-y-1 opacity-70 scale-95"
                      : "transform translate-y-0 opacity-100 scale-100"
                  }`}
                  key={countdown}
                >
                  {countdown}
                </span>
              </div>
            </>
          ) : (
            <p className="text-3xl font-bold">Ready for your interview!</p>
          )}
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default Countdown;
